import { createLucideIcon, type IconNode } from "lucide-react"

const iconNode: IconNode = [
  ["rect", { width: "22", height: "19", x: "1", y: "2.5", rx: "2.5", key: "frame" }],
  [
    "path",
    {
      d: "M9.3 5.8 Q10.4 9.7 14.3 10.8 Q10.4 11.9 9.3 15.8 Q8.2 11.9 4.3 10.8 Q8.2 9.7 9.3 5.8 Z",
      strokeWidth: "1.6",
      key: "sparkle-lg",
    },
  ],
  [
    "path",
    {
      d: "M16.2 12.5 Q16.75 14.45 18.7 15 Q16.75 15.55 16.2 17.5 Q15.65 15.55 13.7 15 Q15.65 14.45 16.2 12.5 Z",
      strokeWidth: "1.6",
      key: "sparkle-sm",
    },
  ],
]

export const PostProductionIcon = createLucideIcon("post-production", iconNode)
